module.exports = __webpack_public_path__ + "img/clientLogo_presentation.cded94c4.png";